module.exports = __webpack_public_path__ + "static/media/chain_lightning.5a6f61d2.png";